import { Component, inject } from '@angular/core';
import { LoadingIndicatorService } from '#services';

@Component({
  selector: 'app-loading-indicator',
  imports: [],
  templateUrl: './loading-indicator.component.html',
  styleUrl: './loading-indicator.component.scss',
})
export class LoadingIndicatorComponent {
  private _loadingIndicator = inject(LoadingIndicatorService);
  visible = this._loadingIndicator.visible;
}
